<template>
  <div class="row skillitem">
    <div class="col-xs-12 vcenter">
      <div class="col-xs-12 vcenter">
        <p class="skillitem-title">{{ value.category }}</p>

        <p class="skillitem-value" v-for="val in value.value" :key="val">{{ val }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkillItem",
  props: {
    value: {
      category: String,
      value: []
    }
  }
};
</script>
